
import BaseBlock from '@headlines/utils/BaseBlock';
import BlockTypeSettings from '@headlines/types/block/111-120/blockType119';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';
import Swiper from '@core/components/UI/swiper/Swiper.vue';

const defaultSettings = {
  config: [
    {
      image: '',
      title: '',
      url: '',
      external: false,
    },
  ],
};

export default BaseBlock<BlockTypeSettings>(defaultSettings).extend({
  components: {
    LinkHandler,
    Swiper,
  },
  computed: {
    swiperOptions() {
      return {
        spaceBetween: 20,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
          hide: false,
        },
        breakpoints: {
          320: {
            slidesPerView: 1.5,
          },
          768: {
            slidesPerView: 4,
          },
          1024: {
            slidesPerView: 4,
            scrollbar: {
              el: '.swiper-scrollbar',
              draggable: false,
              hide: true,
            },
          },
        },
      };
    },
  },
});
